import React from "react"
import { Link, RichText, Date } from 'prismic-reactjs';
import Article from "../components/article";
import Down from "../svg/down-arrow-circle";
import styled from "styled-components";
import * as vars from "../style/vars";
import { above, below } from "../style/functions";
import shader from 'shader'
import Header from "../components/header.js"
import Contact from "../components/contact";
import Map from "../components/google_map";
import StickyEnquire from "../components/sticky-enquire";


class errorPage extends React.Component {

	componentWillMount() {
		this.props.updateMeta(this.props.data.prismicContactPage.data.meta_title.text, this.props.data.prismicContactPage.data.meta_description);
		this.props.updateSlug(this.props.data.prismicContactPage.uid);
		this.props.togglePopup(false);
		this.props.updatePageType(this.props.data.prismicContactPage.type);
		this.props.updateProductHide(false);
		this.props.updateFooterVisible(true);
	}
	render() {

		let data = JSON.parse(this.props.data.prismicContactPage.dataString);
		
		const hours = ''; // this.props.data.prismicContactPage.data.body[0].primary.opening_hours.html
		const message = this.props.data.prismicContactPage.data.close_message.text

		// const map = data.body[1].primary.location;
		// const map_static = data.body[1].primary.alternative_static_map_image;

		return (
			<div>
				<Header togglePopup={this.props.togglePopup} theme="dark" menu={this.props.data.prismicMainNavigation.data} />
				<StickyEnquire theme="light" togglePopupState={this.props.popupVisible} togglePopup={this.props.togglePopup} utm={this.props.utm} updateFormDetails={(first_name,last_name,phone,email) => this.props.updateFormDetails(first_name,last_name,phone,email)}/>

				<Contact people={data.body[0].items} bg={data.body[0].primary.image.url} hours={hours} message={message} />

				{/* { ! map_static ?
					<Map lat={data.body[1].primary.location.latitude} lng={data.body[1].primary.location.longitude} />
				:
					<MapStatic>
						<picture>
							<source srcSet={map_static.Mobile.url} media="(max-width: 600px)" />
							<source srcSet={map_static.Tablet.url} media="(max-width: 840px)" />

							<img src={map_static.url} alt={map_static.alt} draggable={false} />
						</picture>
					</MapStatic>
				} */}
			</div>
		)
	}
}




export default errorPage

const MapStatic = styled.div`
	width: 100%;
	height: 700px;

	${below.tablet`
		height: 650px;
	`}

	${below.mobile`
		height: 500px;
	`}

	picture {
		height: 100%;
		width: 100%;
	}

	img {
		height: 100%;
		width: 100%;
		object-fit: cover;
	}
`

const ArticleWrapper = styled.div`
padding-bottom: ${vars.padding.outer}rem;
${below.mobile`
	padding-bottom: ${vars.padding.mobOuter}rem;
`}
  img {
    width: 100%;
		position: relative;
		z-index: 6;
  }
  .content-container {
    padding-top: ${vars.padding.inner}rem;
  }
  .content-container .title {
    font-weight: bold;
    border-left: 1px solid ${vars.colors.offColor};
		position: relative;
  }
	h1{
		margin-bottom: 1rem;

	}
	.headline{
		h1, p{ padding-bottom: ${vars.padding.inner}rem;

		${below.mobile`
			padding-bottom: ${(vars.padding.mobInner)}rem;

		`}
		}
	}
	.icon svg {
		cursor: pointer;
		width: 3.5rem;
		${below.tablet`
			width: 2rem;
			margin-bottom: ${vars.padding.tabInner}rem;
		`}
	 circle{
		stroke-color: ${vars.colors.blank} !important;
		fill: ${vars.colors.body} !important;
	}
	path{
		stroke: ${vars.colors.blank} !important;
	}
	}
  .content {
    padding-left: ${vars.padding.inner / 2}rem;
    border-left: 1px solid ${vars.colors.offColor};
		${below.mobile`
			padding-left: ${vars.padding.mobInner}rem;
		`}
		blockquote{
			font-style: italic;
		}
  }

	.title a{
		font-size: 1.2rem;
		color: ${shader(vars.colors.body, + 0.4)}
	}
  .title .sec {
    max-width: 300px;
    padding-left: ${vars.padding.inner / 2}rem;
		padding-bottom: ${vars.padding.inner}rem;
		display: block;
		position: relative;
		z-index: 5;
		${props => props.sideFixed && above.tablet`
			position: fixed;
			top: 92px;
		`}
		${below.mobile`
			padding-left: ${vars.padding.mobInner}rem;
		`}
  }
  ${above.tablet`
  .headline {
    padding-top: ${vars.padding.inner * 5}rem;
    padding-bottom: ${vars.padding.inner * 2}rem;
  }
  .desktop-hide{
    display: none
  }
  .content-container {
    display: flex;
  }


  `}
  ${below.tablet`
  .mobile-hide{
    display: none
  }
  .headline {
    padding-top: ${vars.padding.inner}rem;
    padding-bottom: ${vars.padding.inner / 2}rem;
  }
  .title > p{
    padding-left: ${vars.padding.inner / 4}rem;
  }
`};
`;
const DownArrow = styled.div`



`

export const pageQuery = graphql`
   query contactPage($id: String) {
      prismicContactPage(id: { eq: $id }) {
		id
		uid
		type
		dataString
		data {
			body {
				... on PrismicContactPageBodyHero {
					# primary {
					# 	opening_hours {
					# 		html
					# 	}
					# }
					items {
						content1 {
							html
						}
					}
				}
				# ... on PrismicContactPageBodyMap {
				# 	primary {
				# 		location {
				# 			latitude
				# 			longitude
				# 		}
				# 		alternative_static_map_image {
				# 			dimensions {
				# 				width
				# 				height
				# 			}
				# 			alt
				# 			url
				# 			Tablet {
				# 				dimensions {
				# 					width
				# 					height
				# 				}
				# 				url
				# 			}
				# 			Mobile {
				# 				dimensions {
				# 					width
				# 					height
				# 				}
				# 				url
				# 			}
				# 		}
				# 	}
				# }
			}
			meta_title {
				html
				text
			}
			meta_description
			close_message{
				text
			}
		}
	}
	prismicMainNavigation {
		id
		dataString
		data {
		  display_name {
			html
			text
		  }
		  nav {
			slice_type
			primary {
			  label {
				text
			  }
			  link {
				text
			  }
			}
			items {
			  sub_nav_link_label {
				text
			  }
			  sub_nav_link {
				text
			  }
			}
		  }
		}
	  }
   }
`



// WEBPACK FOOTER //
// ./src/templates/contact.js